import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from "./add-new-user.service"
import {Products} from "./add-new-user.service"

export interface UnauthorizedCabinetAccess {
  cuid: string;
  cabinet_users_id: string;
  product_id: string;
  created_at: string;
  updated_at: string;
  cabinet_users: User;
  product: Products;
}

export interface UnauthorizedCabinetAccessResponse {
  data: UnauthorizedCabinetAccess[];
}

@Injectable({
  providedIn: 'root'
})
export class UnauthorizedCabinetAccessService {

  constructor(private http: HttpClient) { }

  getUnauthorizedCabinetAccessSummary(user = null): Observable<UnauthorizedCabinetAccessResponse> {
    if(user){
      console.log("hello78")
      console.log(user);
      console.log(`${environment.apiUrl}/api/cabinet-unauthorized/${user}`)
      // const user_id = user.cuid;
      const ret =  this.http.get<UnauthorizedCabinetAccessResponse>(`${environment.apiUrl}/api/cabinet-unauthorized/${user}`);
      console.log(ret)
      return ret;
    }
    else{
      console.log("hello78")
      const ret =  this.http.get<UnauthorizedCabinetAccessResponse>(`${environment.apiUrl}/api/cabinet-unauthorized`);
      console.log(ret)
      return ret;
    }
  }

}
